export const jsonStringify = (data: unknown) => {
    const pretty = JSON.stringify(data, null, 4);

    // Match blocks like:
    // [
    //     1,
    //     2,
    //     3
    // ]
    const inlineArrays = pretty.replace(/\[\s+([^[\]]*?)\s+]/g, match => {
        const compact = match
            .split('\n')
            .map(line => line.trim())
            .filter(line => line.length && line !== '[' && line !== ']')
            .join(' ');
        return `[ ${compact} ]`;
    });

    return inlineArrays;
};